import {Component, OnDestroy, OnInit} from '@angular/core';
import {RepublicaMovilService} from '../../services/republica-movil.service';
import {Order} from '../../classes/order';
import {RmOrderService} from '../../services/rm-order.service';
import {RmShoppingCartService} from '../../services/rm-shopping-cart.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { RmGlobals } from '../../classes/rm-globals';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-rm-shopping-cart',
    templateUrl: './rm-shopping-cart.component.html',
    styleUrls: ['./rm-shopping-cart.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmShoppingCartComponent implements OnInit, OnDestroy {
    public order: Order;
    public typeOrder: string;
    public rateFtth = null;
    public ratesMobiles = [];
    public totalPrice = 0;
    private allSubscription: Subscription[] = [];

    constructor(
        public matDialog: MatDialog,
        private rmService: RepublicaMovilService,
        private orderService: RmOrderService,
        private shoppingCart: RmShoppingCartService,
        private rmGlobals: RmGlobals
    ) { }

    ngOnInit(): void {
        this.allSubscription.push(this.rmService.getTypeOrder()
            .subscribe((data: any) => {
                this.typeOrder = data;
            })
        );

        this.allSubscription.push(this.rmService.getRateFtth()
            .subscribe((data: any) => {
                this.rateFtth = data;
                this.totalPrice = this.rmGlobals.updateTotalPrice(this.rateFtth, this.ratesMobiles);
            })
        );

        this.allSubscription.push(this.rmService.getRatesMobile()
            .subscribe((data: any) => {
                if (data != null) {
                    this.ratesMobiles = data;
                    this.totalPrice = this.rmGlobals.updateTotalPrice(this.rateFtth, this.ratesMobiles);
                }
            })
        );

        this.allSubscription.push(this.orderService.getOrder()
            .subscribe((data: any) => {
                if (data != null) {
                    this.order = data;
                    if (this.ratesMobiles && this.ratesMobiles.length && this.order.mobiles && this.order.mobiles.length) {
                        this.order.mobiles.map(item => {
                            const found = this.ratesMobiles.filter(x => x.packageId === item.rate_package_id)
                            if (found) {
                                item.rate = found[0];
                            }
                        });
                    }
                }
            })
        );

        this.allSubscription.push(this.shoppingCart.getShow()
            .subscribe((data: boolean) => {
                if (data) {
                    this.openCart();
                } else {
                    this.closeCart();
                }
            })
        );
    }

    priceWithIVA(price: number): number {
        return price * 1.21;
    }

    closeShoppingCart() {
        this.shoppingCart.setShow(false);
    }

    openCart() {
        if (document.getElementById('shopping-cart') !== null) {
            document.getElementById('shopping-cart').style.width = '350px';
        }
    }

    closeCart() {
        if (document.getElementById('shopping-cart') !== null) {
            document.getElementById('shopping-cart').style.width = '0px';
        }
    }

    goToStep(index) {
        this.shoppingCart.getStepper().selectedIndex = index;
    }

    removeExtraLine(index) {
        this.matDialog
            .open(ConfirmDialogComponent, {
                data: {
                    title: 'Eliminar linea móvil adicional',
                    message: '¿Está seguro de querer eliminar la linea móvil adicional?'
                },
                panelClass: 'rm'
            })
            .afterClosed()
            .subscribe((confirm: boolean) => {
                if (confirm) {
                    this.orderService.removeOrder(index);
                    this.rmService.removeLine(index);
                    this.rmService.setIndexToRemove(index);
                    this.totalPrice = this.rmGlobals.updateTotalPrice(this.rateFtth, this.ratesMobiles);
                }
            });
    }

    public getAddress(): string {
        if (this.order && this.order.broadband) {
            let address: string = '';
            address += this.parseText(this.order.broadband.street_type ? this.order.broadband.street_type + ' ' : '');
            address += this.parseText(this.order.broadband.street_name ? this.order.broadband.street_name + ' ' : '');
            address += this.parseText(this.order.broadband.street_number ? this.order.broadband.street_number + ' ' : '');
            address += this.parseText(this.order.broadband.floor_number ? this.order.broadband.floor_number + ' ' : '');
            address += this.parseText(this.order.broadband.apartment_number ? this.order.broadband.apartment_number + ' ' : '');
            address += this.parseText(this.order.broadband.staircase_number ? this.order.broadband.staircase_number + ', ' : ', ');
            address += this.parseText(this.order.broadband.post_code ? this.order.broadband.post_code + ' ' : '');
            address += this.parseText(this.order.broadband.city ? this.order.broadband.city + ', ' : ', ');
            address += this.parseText(this.order.broadband.province ? this.order.broadband.province + ' ' : '');

            return address;
        }
    }

    public parseText(text) {
        if (typeof text !== 'string') {
            return '';
        }
        let textUCfirst = '';
        for (let i = 0; i < text.length; i++) {
            if (i === 0) {
                textUCfirst += text.charAt(i).toUpperCase();
            } else {
                textUCfirst += text.charAt(i).toLowerCase();
            }
        }
        return textUCfirst;
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
